import $ from 'jquery'
import {setSameHeight} from '../abstracts/utils'

export default () => {
  $(() => {
    if (!$('body').hasClass('archive') && !$('body').hasClass('post-type-archive-product')) return

    setSameHeight($('.section-products .products .cadin-post .entry-title'))
    $('form#product-filter').submit(e => {
      e.preventDefault()
      const productCategories = $(e.target).find('input[name=product_cat]:checked')
      let queryProductCategories = ''
      productCategories.map((index, item) => {
        queryProductCategories += $(item).val() + ','
      })
      if (queryProductCategories) queryProductCategories = queryProductCategories.substring(0, queryProductCategories.length - 1)
      const url = new URL(`${location.origin}${location.pathname}`)
      url.searchParams.set('product_cat', queryProductCategories)
      location.href = url
    })
  })
}
